import { useState, useRef } from "react";
import { Card, CardBody, CardText, Form, Row, Col } from "reactstrap";
// drop
import Dropzone from "react-dropzone";
// componentes
import ModeloUpload from "../../../assets/statics/modelo_hotel_deletar.xlsx";
import ModalExcelRows from "../Voo/ModalExcelRows";
// utils e services
import readXlsxFile from "read-excel-file";
import { formatBytes } from "../../../utils/helpers/files/formatBytes";
import { deleteHotel } from "../../../utils/services/hotel";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// validadores
import {
  allExcelColumnsDelete,
  excelColumnsPtBrDelete,
  getValidHotels,
} from "./importHotelValidation";
import { findRowsWithError } from "../Voo/importValidation";

export default function ImportDeleteFlight(props) {
  const { idEvent, data, toggleModal } = props;
  // arquivos selecionados e envio
  const [selectedFiles, setselectedFiles] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  // botoes
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);
  // erros e alertas
  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState(false);
  const [success_dlg, setsuccess_dlg] = useState(false);
  // importando
  const importActivated = useRef(false);

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setselectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
  }

  function cancelImport() {
    importActivated.current = false;
    setselectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  async function uploadService() {
    importActivated.current = true;

    setBtnSend(false);
    setBtnCancel(true);

    const schema = {
      IdHotel: {
        prop: "id",
        type: String,
      },
      NomeParticipante: {
        prop: "name",
        type: String,
      },
    };

    let count = 1;

    const readXlsx = async () => {
      const { rows } = await readXlsxFile(selectedFiles[0], { schema });
      const validateRows = rows.map((row, i) => allExcelColumnsDelete(row, i));

      setTotalRows(validateRows?.length);

      // validar colunas se esta no padrão
      const rowsWithoutSchema = await readXlsxFile(selectedFiles[0]);
      const header = rowsWithoutSchema[0];
      const schemaCreate = Object.keys(schema);

      function isEqual(schema, header) {
        if (schema.length !== header.length) return false;

        return (
          schema.every((item) => header.includes(item)) &&
          header.every((item) => schema.includes(item))
        );
      }

      if (!isEqual(schemaCreate, header)) {
        setErrors([]);
        setModalErrors(true);
        return;
      }

      // validar campos vazios
      const rowsWithError = findRowsWithError(validateRows);

      if (rowsWithError.length > 0 || rows.length === 0) {
        setErrors(rowsWithError);
        setModalErrors(true);
        return;
      }

      // validar se todos objetos estão cadastrados para poderem ser atualizados
      const validsHotel = await getValidHotels(validateRows, idEvent);

      if (validsHotel?.length > 0) {
        setErrors(validsHotel);
        setModalErrors(true);
        return;
      }

      for (const row of validateRows) {
        await deleteHotelFunc(row, validateRows.length);
      }
    };

    readXlsx();

    async function deleteHotelFunc(row, totalRows) {
      await deleteHotel({
        jwt: "",
        id: row.id,
      })
        .then((res) => {
        //   console.log("deleted", res);
          if (res.message === "DELETED_HOTEL") {
            count++;
            setTotalSended(count);
          }

          if (count === totalRows || (count === 2 && totalRows === 1)) {
            setsuccess_dlg(true);
          }
        })
        .catch((error) => {
           setBtnCancel(false);
        //   console.log("delete erro", error);
        });
    }
  }

  return (
    <>
      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors}
          columnNames={excelColumnsPtBrDelete}
        />
      )}

      {success_dlg ? (
        <SweetAlert
          success
          title={"Upload"}
          onConfirm={() => {
            data();
            toggleModal();
            setsuccess_dlg(false);
          }}
        >
          {"Os Hotéis foram apagados com sucesso!"}
        </SweetAlert>
      ) : null}

      <Card className="p-1">
        <CardBody className="m-1 p-2">
          <CardText className="mb-2 p-10">
            O arquivo a ser importado deve seguir este{" "}
            <a href={ModeloUpload} download="modelo_hotel_deletar.xlsx">
              Modelo
            </a>
            , não modifique seu cabeçalho.
          </CardText>

          <Form>
            {selectedFiles.length === 0 && (
              <Dropzone
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles);
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div
                      className="dz-message needsclick mt-1"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-4">
                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                        <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>
            )}
            <div className="dropzone-previews mt-0" id="file-previews">
              {selectedFiles.map((f, i) => {
                return (
                  <Card
                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                    key={i + "-file"}
                  >
                    <div className="p-1">
                      <Row className="align-items-center">
                        <Col xs="11">
                          <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                        </Col>
                        <Col xs="1">
                          <span
                            style={{
                              fontSize: "16px",
                              color: "red",
                              fontWeight: "700",
                            }}
                            className="mdi mdi-close"
                            onClick={() => setselectedFiles([])}
                          />
                        </Col>
                      </Row>
                      {importActivated.current && (
                        <Row className="align-items-center">
                          <Col>
                            <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </Card>
                );
              })}
            </div>
          </Form>

          <div className="text-center mt-3">
            <button
              type="button"
              disabled={!btnSend}
              className="btn btn-primary waves-effect waves-light"
              onClick={() => uploadService()}
            >
              Deletar Hotéis
            </button>
            <button
              type="button"
              className="btn btn-danger mx-1"
              disabled={!btnCancel}
              onClick={() => cancelImport()}
            >
              Cancelar
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
